import { useParams } from "react-router-dom";
import OrderBumpList from "@/pages/EditProduct/Orderbumps/Partials/OrderBumpList.tsx";

export default function Orderbumps() {
  return (
    <>
      <div className='flex items-center justify-center h-full'>
        <OrderBumpList productId={useParams().id} />
      </div>
    </>
  );
}
